import styled from 'styled-components';
import { BasePanel } from 'styles/components';
import { Colors } from 'styles/constants';

export {
  ActivityIndicator,
  ArrowLeftIcon,
  Button,
  FormActions,
  FormRow,
  LinkButton,
  OperationIcon as AreaIcon,
} from 'styles/components';

export const MainPanel = styled(BasePanel)`
  flex: 0 1 100%;
  flex-direction: column;
  background: ${Colors.White};
  padding: 24px;
`;
